import React from 'react'
import { Label } from '../input/input'
import { SubmitButton } from '../input/button'
import './style.css'

export const ForgotForm = ({
  emailForgot,
  handleForgotPasswordInputChange,
  sendNewPassword,
  setForm,
  loading,
}) => (
  <div className="form-container">
    <h2 className="signin-title">¿Olvidaste tu contraseña?</h2>
    <p className="signin-subtitle">
      Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
    </p>
    <div className="form-group">
      <Label value="Correo electrónico" />
      <input
        className="input-base"
        type="email"
        value={emailForgot}
        name="emailForgot"
        placeholder="correo@ejemplo.com"
        onChange={handleForgotPasswordInputChange}
      />
    </div>
    <SubmitButton
      text="Restablecer Contraseña"
      onClick={() => sendNewPassword(emailForgot)}
      loading={loading}
      loadingText="Enviando..."
      type="button"
    />
    <div className="recover-text" style={{ marginTop: '1.5rem' }}>
      ¿Recordaste tu contraseña?{' '}
      <span className="signin-recover-text" onClick={() => setForm('login')}>
        Volver al inicio
      </span>
    </div>
  </div>
)
